import React from "react";
import TabularLiveViewMeta from "./TabularLiveViewMeta";
import {useLiveViewContext} from "../LiveViewProvider";
import {toast} from "react-toastify";
import {resetPlayerData, sendPlayerAlert} from "../live.view.api.services";
import ScoreCardDetailsModal from "./ScoreCardDetailsModal";
import { Height } from "@material-ui/icons";

const TableRow = ({player}) => {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);

    const {id: holeId, name: hole_name} = player.hole
    const {id: userId, golf_match: matchId, score_card_id, name: playerName, alerts_count} = player.user;
    const {spent_time, label, target_time, color, alert_type, start_time} = player.status;

    const sendAlert = async () => {
        const alert_data = {
            send_to: userId,
            alert_type: alert_type,
            holepoint: holeId,
            match_id: matchId
        }
        try {
            const res = await sendPlayerAlert(alert_data);
            if (res.data.status === "SUCCESS") {
                toast.success("Alert Sent successfully.");
            }
        } catch (err) {
            console.log(err);
            toast.error("Error");
        }
    }

    const resetPlayer = async () => {
        const player_data = {
            "user_id": userId,
            "hole_id": holeId,
            "match_id": matchId
        }
        try {
            const res = await resetPlayerData(player_data);
            if (res.data.status === "SUCCESS") {
                toast.success("Player reset successfully.");
            }
        } catch (err) {
            console.log(err);
            toast.error("Error");
        }
    }

    return (
        <>

            <ScoreCardDetailsModal
                handleClose={() => setOpen(false)}
                open={open}
                scoreCardId={score_card_id}
                golferDetails={
                    {name: player.user.name}
                }
            />

            <tr
                style={{background: `${color}`}}
                className="live-view_table_cell"
            >
                <td className="table__row-0">{hole_name}</td>
                <td className="table__row-0">{playerName}</td>
                <td className="table__row-0">{target_time}</td>
                <td className="table__row-0">{spent_time}</td>
                <td className="table__row-0">{start_time.split('.')[0]}</td>
                <td className="table__row-0">
                    <button className="view_button" onClick={handleOpen}>VIEW</button>
                </td>

                <td className="table__row-0">
                    <button
                        disabled={label === "on-time"}
                        className={label === "on-time" ? "res-btn-gray-md" : "res-btn-primary-md"}
                        onClick={sendAlert}>Send Alert
                    </button>
                </td>
                <td>
                    <span style={{color: 'black'}}>({alerts_count} alerts today)</span>
                </td>
                <td className="table__row-0">
                    <button className="res-btn-gray-md" onClick={resetPlayer}>Reset Player</button>
                </td>
            </tr>


        </>


    )
}


export const TabularLiveView = ({isActive}) => {

    const {state, setState} = useLiveViewContext();
    const {courseData, playersLiveData, courseLoading, courseList} = state;
    const {players} = playersLiveData || {};

    if (courseLoading || !courseData) return "";

    return (
        <>

<div className="center-align">
            <div className={isActive ? "content  active-content" : "content"}>
            <div style={{height:"100vh"}}>
                <TabularLiveViewMeta/>
               <div style={{ justifyContent: "space-between", overflow: "auto" }}>
  <table className="live-view_table">
    {/* Table Head */}
    <thead>
      <tr className="live-view_table_head">
        <th className="table__row-0">Hole</th>
        <th className="table__row-0">Golfer</th>
        <th className="table__row-0">Target Time</th>
        <th className="table__row-0">Time so Far</th>
        <th className="table__row-0">Start Time</th>
        <th className="table__row-0">Details</th>
        <th className="table__row-0">Actions</th>
        <th className="table__row-0">Total Alerts</th>
        <th className="table__row-0">Reset</th>
      </tr>
    </thead>

    {/* Table Body */}
    <tbody>
      {players?.length > 0 ? (
        players.map((player, i) => (
          <TableRow player={player} key={i.toString()} />
        ))
      ) : (
        <tr>
          <td style={{ color: "black" }} className="text-jost-sb-20" colSpan="9">
            No Live Players
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

                </div>
            </div>
            </div>
        </>
    );
};
